import React, { useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Home, 
  Users, 
  Gamepad2, 
  HelpCircle,
  Crosshair,
  MessageCircle
} from "lucide-react";

interface BottomMenuLink {
  to: string;
  label: string;
  icon: React.ReactNode;
}

export const BottomFixedMenu: React.FC = () => {
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const navigationLinks: BottomMenuLink[] = [
    { to: "/", label: "Início", icon: <Home className="w-5 h-5" /> },
    { to: "/mentores", label: "Mentores", icon: <Users className="w-5 h-5" /> },
    { to: "/comunidades", label: "Comunidades", icon: <MessageCircle className="w-5 h-5" /> },
    { to: "/jogos", label: "Jogos", icon: <Gamepad2 className="w-5 h-5" /> },
    { to: "/mentorias", label: "Mentorias", icon: <Crosshair className="w-5 h-5" /> },
    { to: "/como-funciona", label: "Como Funciona", icon: <HelpCircle className="w-5 h-5" /> },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-[#181D24] to-[#1A2233] border-t border-[#222A35] shadow-lg">
      {/* Scroll indicator */}
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#222A35]">
        <div className="h-full bg-gradient-to-r from-[#00B6F0] to-[#5fceff] w-1/3 rounded-full"></div>
      </div>
      
      <div 
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide py-3 px-4 space-x-1 scroll-smooth"
        style={{ 
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
          scrollBehavior: 'smooth'
        }}
      >
        {navigationLinks.map((link) => {
          const isActive = location.pathname === link.to ||
                          (link.to !== "/" && location.pathname.startsWith(link.to));
          
          return (
            <Link
              key={link.to}
              to={link.to}
              className={`flex flex-col items-center justify-center min-w-[90px] py-2 px-3 rounded-lg whitespace-nowrap shrink-0 ${
                isActive
                  ? "bg-[#223342] text-[#00B6F0]"
                  : "text-gray-400"
              }`}
              style={{ scrollSnapAlign: 'center' }}
            >
              <span className={`mb-1 ${isActive ? "text-[#00B6F0]" : "text-gray-400"}`}>
                {link.icon}
              </span>
              <span className="text-xs font-medium text-center leading-tight">
                {link.label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#00B6F0] rounded-full"></div>
              )}
            </Link>
          );
        })}
      </div>
      
      {/* Safe area for iOS */}
      <div className="h-safe-area-inset-bottom bg-gradient-to-r from-[#181D24] to-[#1A2233]"></div>
    </div>
  );
}; 